document.addEventListener('DOMContentLoaded', function() {
  const paymentsPage = document.querySelector('.payments-management');
  if (!paymentsPage) {
    return;
  }

  const planSelect = document.getElementById('option-plan');
  const optionPlanModal = document.getElementById('option-plan-confirm-modal');
  const optionPlanCancel = document.getElementById('option-plan-cancel');
  const optionPlanConfirm = document.getElementById('option-plan-confirm');
  const optionPlanClose = document.getElementById('option-plan-close');
  let originalPlanValue = planSelect ? planSelect.value : null;
  let pendingPlanValue = null;
  let pendingUserId = null;

  if (planSelect && optionPlanModal) {
    planSelect.addEventListener('change', function() {
      pendingPlanValue = this.value;
      pendingUserId = this.dataset.userId;
      optionPlanModal.classList.remove('hidden');
    });
  }

  function hideOptionPlanModal() {
    if (optionPlanModal) {
      optionPlanModal.classList.add('hidden');
    }
  }

  if (optionPlanCancel && planSelect) {
    optionPlanCancel.addEventListener('click', function() {
      planSelect.value = originalPlanValue;
      pendingPlanValue = null;
      pendingUserId = null;
      hideOptionPlanModal();
    });
  }

  if (optionPlanClose && planSelect) {
    optionPlanClose.addEventListener('click', function() {
      planSelect.value = originalPlanValue;
      pendingPlanValue = null;
      pendingUserId = null;
      hideOptionPlanModal();
    });
  }

  if (optionPlanConfirm && planSelect) {
    optionPlanConfirm.addEventListener('click', function() {
      if (!pendingPlanValue || !pendingUserId) {
        hideOptionPlanModal();
        planSelect.value = originalPlanValue;
        return;
      }

      fetch(`/admin/users/${pendingUserId}/assign_plan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ plan: pendingPlanValue })
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          hideOptionPlanModal();
          location.reload();
        } else {
          alert('プランの更新に失敗しました');
          planSelect.value = originalPlanValue;
          hideOptionPlanModal();
        }
      })
      .catch(error => {
        console.error('Error:', error);
        alert('エラーが発生しました');
        planSelect.value = originalPlanValue;
        hideOptionPlanModal();
      });
    });
  }

  const paymentMethodModal = document.getElementById('payment-method-confirm-modal');
  const paymentMethodMessage = document.getElementById('payment-method-confirm-message');
  const paymentMethodConfirmBtn = document.getElementById('payment-method-confirm');
  const paymentMethodCancelBtn = document.getElementById('payment-method-cancel');
  const paymentMethodCloseBtn = document.getElementById('payment-method-modal-close');
  const paymentMethodContainer = document.querySelector('[data-current-payment-method]');
  let pendingPaymentMethod = null;
  let pendingPaymentUserId = null;

  function hidePaymentMethodModal() {
    if (paymentMethodModal) paymentMethodModal.classList.add('hidden');
  }

  if (paymentMethodCloseBtn) {
    paymentMethodCloseBtn.addEventListener('click', hidePaymentMethodModal);
  }
  if (paymentMethodCancelBtn) {
    paymentMethodCancelBtn.addEventListener('click', hidePaymentMethodModal);
  }

  const paymentMethodToggles = document.querySelectorAll('.payment-method-toggle');
  paymentMethodToggles.forEach(button => {
    button.addEventListener('click', function() {
      const targetMethod = this.dataset.paymentMethod;
      const userId = this.dataset.userId;
      const currentMethod = paymentMethodContainer ? paymentMethodContainer.dataset.currentPaymentMethod : null;
      if (targetMethod === currentMethod) return;

      const fromLabel = currentMethod === 'single' ? 'Single' : 'Business';
      const toLabel = targetMethod === 'single' ? 'Single' : 'Business';
      if (paymentMethodMessage) {
        paymentMethodMessage.textContent = 'ユーザーのプランを' + fromLabel + 'から' + toLabel + 'に変更しますか？';
      }
      pendingPaymentMethod = targetMethod;
      pendingPaymentUserId = userId;
      if (paymentMethodModal) paymentMethodModal.classList.remove('hidden');
    });
  });

  if (paymentMethodConfirmBtn) {
    paymentMethodConfirmBtn.addEventListener('click', function() {
      if (!pendingPaymentMethod || !pendingPaymentUserId) {
        hidePaymentMethodModal();
        return;
      }
      fetch(`/admin/users/${pendingPaymentUserId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ user: { payment_method: pendingPaymentMethod } })
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          hidePaymentMethodModal();
          location.reload();
        } else {
          alert('ベースプランの更新に失敗しました');
          hidePaymentMethodModal();
        }
      })
      .catch(error => {
        console.error('Error:', error);
        alert('エラーが発生しました');
        hidePaymentMethodModal();
      });
    });
  }
});

